const zh = {
  finishOrder: "完结",
  finishedOrder: "已完结",
  unfinishedOrder: "未完结",
  code: "终端客户编码",
  name1: "终端客户名称1",
  name2: "终端客户名称2",
  shortName: "终端客户简称",
  country: "国籍/区域",
  address: "地址",
  zipCode: "邮政编码",
  email: "Email地址",
  contact: "联系人",
  phone: "电话",
  fax: "传真",
  mobile: "手机",
  account1: "开户银行1",
  bank1: "银行账号1",
  swiftCode1: "银行编码1",
  account2: "开户银行2",
  bank2: "银行账号2",
  swiftCode2: "银行编码2",
  currency: "币种",
  saleType: "销售渠道",
  creditLevel: "信用等级",
  creditLine: "信用额度",
  depositRate: "定金比例(%)",
  tradeTerm: "贸易条款",
  payMethod: "付款方式",
  commissionRate: "佣金比例",
  org: "分管部门",
  billingDays: "帐期(天)",
  principal: "委托方",
  relatedDocuments: "相关资料(合同/营业执照/开票资料)",
  documents: "相关资料",
  affiliates: "关联公司",
  customerList: "终端客户列表",
  addCustomer: "添加终端客户",
  price: "价格",
  shipAddress: "收货地址",
  shipAddressBook: "收货地址簿",
  addShipAddress: "新增收货地址",
  shipAddressName: "收货方名称",
  plShipAddressName: "请输入收货方名称",
  shipAddressType: "收货方类型",
  defaultAddress: "默认地址",
  setDefault: "设为默认地址",
  remark: "备注",
  bySearchShipAddress: "通过收货方名称、地址、电话进行搜索",
  plPrice: "请输入价格",
  priceMax: "最大值为：{{ num }}",
  priceMin: "最小值为：{{ num }}",
  plProductPrice: "请选择商品，可输入存货名称与存货编码进行搜索",
  plCustomer: "请选择终端客户",
  addPrice: "添加商品价格",
  customerRequired: "终端客户信息不能为空",
  productRequired: "产品信息不能为空",
  priceRequired: "价格不能为空",
  product: "商品",
  priceDetail: "价格信息",
  exitsPrice: "已存在该商品价格",
  productInfo: "商品信息",
  orderNumber: "销售订单号",
  internalNumber: "内部单号",
  receivingUnit: "收货单位",
  approvalStatus: "审批状态",
  customerContact: "终端客户联系人",
  receivingContact: "收货联系人",
  customerContactPhone: "终端客户联系人电话",
  receivingContactMobile: "收货联系人手机",
  orderType: "销售类型",
  plOrderType: "请选择销售类型",
  taxRate: "税率（%）",
  quantity: "数量",
  materialStatus: "物料齐料状态",
  productionStatus: "生产状态",
  shipmentStatus: "发货状态",
  receivingStatus: "终端客户收货状态",
  paymentStatus: "回款状态",
  receivingAddress: "收货地址",
  realPrice: "真实价格",
  totalPrice: "总价",
  revisePrice: "调整价格",
  actualPrice: "实际价格",
  orderState: "订单状态",
  passed: "已通过",
  notApproval: "待审批",
  plInnerNumber: "请输入内部单号",
  plReceivingUnit: "请输入收货单位",
  plReceivingContact: "请输入收货联系人",
  plReceivingContactMobile: "请输入收货联系人手机号",
  plReceivingAddress: "请输入收货地址",
  orderProduct: "订单商品",
  plMfgr: "请输入公司型号",
  plCustomerModel: "请输入终端客户型号",
  plProductName: "请输入商品名称",
  plReqDeliDate: "请选择出货要求时间",
  plSmtStartDate: "请选择预计上线日期",
  plPreFinishDate: "请选择预计完工日期",
  plUrgencyLevel: "请输入紧急程度",
  plSpecialReq: "请输入特殊要求",
  plReRemark: "请输入备注",
  plQuantity: "请输入数量",
  customerShortName: "终端客户简称",
  productCode: "存货编码",
  productName: "产品名称",
  productModel: "产品型号",
  productUom: "主计量单位",
  addOrder: "添加订单",
  orderSearchTip:
    "通过订单号、终端客户简称、存货编码、终端客户型号、公司型号、存货名称、产品型号、终端客户编码、终端客户名称1、终端客户名称2进行搜索",
  innerNumber: "内部单号",
  customerModel: "终端客户型号",
  mfgr: "公司型号",
  reRemark: "备注",
  reqDeliDate: "出货要求时间",
  smtStartDate: "预计上线日期",
  preFinishDate: "预计完工日期",
  urgencyLevel: "紧急程度",
  specialReq: "特殊要求",
  orderInfo: "订单信息",
  customerInfo: "终端客户信息",
  proInfo: "产品信息",
  reportInfo: "报表数据",
  saleTotalQuantity: "需生产总数",
  outPro: "出货",
  inStock: "入库",
  dataReportSearch: "通过订单号、终端客户信息、存货信息关键字进行搜索",
  notReportData: "暂无报表数据",
  reportSearchTip:
    "通过订单号、终端客户编码、终端客户简称、存货编码、存货名称进行搜索",
  addEdit: "添加/编辑生产数据",
  productionSearchTip:
    "通过订单号、存货编码、存货名称与终端客户信息关键字进行搜索",
  exitsData: "已有当天数据",
  time: "时间",
  updateSuccess: "修改成功",
  history: "历史详情",
  plCode: "请输入终端客户编码",
  plName1: "请输入终端客户名称1",
  plName2: "请输入终端客户名称2",
  plShortName: "请输入终端客户简称",
  plAddress: "请输入终端客户地址",
  plZipCode: "请输入终端客户邮政编码",
  plEmail: "请输入终端客户Email地址",
  plContact: "请输入联系人",
  plPhone: "请输入终端客户电话",
  plFax: "请输入终端客户传真",
  plMobile: "请输入终端客户手机号",
  plBank1: "请输入银行账号1",
  plAccount1: "请输入开户银行1",
  plSwiftCode1: "请输入银行编码1",
  plBank2: "请输入银行账号2",
  plAccount2: "请输入开户银行2",
  plSwiftCode2: "请输入银行编码2",
  plSaleTypes: "请选择销售类型",
  plCreditLevels: "请选择信用等级",
  plCreditLine: "请输入信用额度",
  plDepositRate: "请输入定金比例",
  plTradeTerms: "请选择贸易条款",
  plPaymentMethod: "请选择付款方式",
  plDictCommissionRate: "请输入佣金比例",
  plAffiliates: "请输入关联公司",
  plBillingDays: "请输入帐期",
  plPrincipal: "请输入委托方",
  plTaxRate: "请输入税率",
  plOrg: "请选择组织",
  saleTypeAdd: "添加销售类型",
  saleTypeDetail: "销售类型详情",
  payAdd: "添加付款方式",
  payDetail: "付款方式详情",
  tradeAdd: "添加贸易条款",
  tradeDetail: "贸易条款详情",
  codeRequired: "终端客户编码必填",
  codeExisted: "终端客户编码已存在",
  prevRequired: "请先添加完上一条数据",
  bySearchCustomer:
    "通过终端客户编码、终端客户名称1、终端客户名称2、终端客户简称、地址进行搜索",
  bySearch:
    "通过存货编码、存货名称、终端客户编码、终端客户名称1、终端客户名称2、终端客户简称、地址进行搜索",
  bySearchPrice: "通过存货编码、存货名称、产品型号进行搜索",
  infoExisted: "该条信息已存在",
  customerNotExist: "终端客户信息不存在或已被删除",
  estimateDays: "预计到货天数",
  expiredAt: "过期时间",
  plEstimateDays: "请填写预计到货天数",
  plExpiredAt: "请选择过期时间",
  shippingMethod: "出货方式",
  plShipping: "请选择出货方式",
  customerType: "终端客户种类",
  plCustomerType: "请选择终端客户种类",
  productNotExisted: "请选择商品",
  orderSuccessProjectError: "订单信息修改成功，商品信息修改失败",
  projectSuccessOrderError: "商品信息修改成功，订单信息修改失败",
  productPre: "选择商品后才可通过审批",
  innerNumberPre: "填写内部单号才可通过审批",
  passError: "审批未通过",
  passSuccess: "审批通过",
  orderList: "订单列表",

  taxPrice: "含税单价",
  plTaxPrice: "请输入含税单价",

  addRequirement: "添加评审单",
  requirement: "需求清单",

  notRequirement: "暂未生成需求清单",
  orderDate: "订单日期",
  selectColumns: "选择导出列",
  editOrder: "修改订单",
  updateErr: "订单信息修改失败",
  exportPI: "导出PI模版",

  aPrice: "调整价格",
  discount: "优惠/折扣",
  sPrice: "销售总价",
  send: "备/赠品",
  sendQuantity: "备/赠品数量",
  sendAPrice: "备/赠品调整价格",
  sendDiscount: "备/赠品优惠折扣",
  sendPrice: "备/赠品总价",
  orderTotal: "订单总价",
  discountHelp: "最大优惠价格不能大于销售价(不包含备品)：{{count}}",

  // Excel导出相关
  quotationSheet: "QUOTATION SHEET",
  to: "TO:",
  mov: "MOV:",
  effectiveDate: "Effective Date:",
  modelNo: "Model #",
  mfgrNo: "MFGR#",
  picture: "Picture",
  descriptionOfProduct: "Description of Product",
  chipSet: "Chip set",
  package: "Package (pcs/ctn)",
  unitPrice: "Unit Price",
  note: "NOTE",
  quotationNote1: "1) Above quotation is based on payment 100% before shipment.",
  quotationNote2: "2) If order value less than 40,000 USD, the price term will be EX-WORK",
  quotationNote3: "3) Quotation validity:  2 WEEKS from Today.",
  quotationNote4: "4) Confirm order by downpayment (deposit)",
  exportFailed: "导出失败：",
  quotationTitle: "报价单",
  contactPerson: "Contact person:",
  officeTel: "Office tel:",
  emailLabel: "E-mail:",
  date: "Date:",
  quotationNumber: "报价单:",
  respectedCustomer: "尊敬的客户",
  quotationIntro: "感谢您对ZIONCOM越南工厂的关注。基于您提供的信息以及希望直接与我们合作的需求，我们很高兴为您提供服务方案以及相关费用报价，供您参考。",
  no: "NO",
  quotationProductCode: "品号",
  quotationProductDesc: "货品描述",
  quotationUnit: "单位",
  quotationCurrency: "币别",
  moqPrice: "MOQ/ 采购未税价",
  attention: "注意：",
  quotationAttention1: "1.报价包含：人工成本、锡膏及运送至 VSIP II 平阳省。",
  quotationAttention2: "2.报价不包含：原材料及增值税（VAT）。",
  quotationAttention3: "3.付款条款：款项须在每月结算后30天内支付。",
  quotationAttention4: "4.最低订购量（MOQ）：如果低于最低订购量1000件，每个订单将收取开模费2,720,000越南盾/订单",
  customerConfirmation: " Customer's confirmation",
  zioncomVietnam: "Zioncom (Vietnam) Jsc",
  inquiryTemplate: "问询单模版",
  quotationTemplate: "报价单模版",
  transferOrder: "订单转单信息",
  customerPriceTemplate: "客户价格模版",
  importCustomerPrice: "导入客户价格",
  swapRes: "转单结果",
  originSale: "原销售单",
  orderNo: "订单号",
  prodOrderNo: "生产订单号",
  oldCode: "旧料号",
  prodCode: "产品编码",
  prodName: "产品名称",
  prodMod: "规格型号",
  count: "数量",
  uom: "单位",
  batch: "批号",
  origin: "部门",
  productor: "物料员",
  confirmer: "品保确认",
  prodManager: "生产主管",
  warehouseer: "仓管员",
  approver: "审核",
  checker: "核准",
  inboundNo: "入库单号",
  inboundDate: "入库日期",
  warehouse: "仓库",
  finishedWarehouse: "成品仓",
  inboundType: "入库类别",
  prodIn: "产成品入库单",
  littleTotal: "小计",
  total: "合计",
  saleSwap: "转销售单",
  purSwap: "转采购单",
  notApi: "该客户没有配置WmsApi，无法进行转单！",
  notSale: "该销售单商品不满足跑需求单条件，无法进行转单！",
  purchaseData: "采购数据",
  confirmGeneratePurOrder: "确定生成采购单么？",
  notCusPros: "客户WMS系统中不存在这些物料，请去客户的WMS系统中先维护这些物料数据",
  notPurProPrice: "客户WMS系统中不存在这些物料的该供应商的采购价格信息，请先去客户WMS系统维护相关采购价格信息",
  purSucc: "采购单生成成功",
  onlyOneCustomer: "只允许选择同一个客户的销售单！",
  editOutPl: "可出库数量已更新，请修改出库数量",
  bomCopyTip: "该销售单具有BOM附件，确定需要一并复制BOM附件到新的单据？",
  bomCopyYes: "复制销售单和BOM附件",
  bomCopyCancel: "仅复制销售单",
  receiverFax: "收货人传真",
  receiverPhone: "收货人电话",
  licenseId: "营业证号码",
  licenseAddress: "营业证登记地址",
  invoiceNumber: "发票号码",
  invoiceAddress: "发票寄送地址",
  printDate: "制表日期",
  printPageNo: "页次",
  domesticSaleOrder: "国内销货单",
  printSaleNo: "销货单号",
  printCustomerName: "客户全名",
  printUnifiedTitle: "营业证号码",
  printOrderDate: "单据日期",
  printSendAddress: "送货地址",
  printPhone: "联系电话",
  printInvoiceNumber: "发票号码",
  printInvoiceAddress: "发票地址",
  printContact: "联系人",
  printRemark: "备注",
  printSeq: "序号",
  printProductName: "品名",
  printQuantity: "销货数量",
  printBQuantity: "赠/备品量",
  printUom: "单位",
  printPrice: "单价",
  printAmount: "金额",
  onlyOneSelectip: "请选择一条单据",
  printSale: "打印销售单",
  printTotalQuantity: "数量合计",
  printSaleAmount: "本币销货金额",
  printSaleTax: "本币销货税额",
  printTotalAmount: "本币金额合计",
  orderPrintLeft: "签收后，请交货人员捎回或传真回：{{fax}}，谢谢！！",
  orderPrintRight: "自存联（白） 会计联（蓝） 签收联（红） 客户联（黄）",
  printApprove: "核准",
  printWarehouse: "仓库",
  printSales: "业务",
  printMaker: "制单",
  printCustomerSign: "客户签收",
  toOfficial: "转正式订单",
  toOfficialConfirm: "确定将选中的 {{count}} 个订单转为正式订单吗？",
  toOfficialSingleConfirm: "确定转为正式订单？",
  toOfficialSuccess: "转正式订单成功",
  toOfficialError: "以下订单转正式订单失败",
  toOfficialHasRequirement: "以下订单已有需求清单，不能转正式订单",
}

export default zh;
